const slugify = (value) => {
  return value
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/&/g, "-und-")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const initNavigation = () => {
  const navigation = document.querySelector("#navigation");
  const toggleButton = document.querySelector("#toggleButton");
  const navPanel = document.querySelector("#navPanel");
  const navLinks = Array.from(document.querySelectorAll("[data-nav-link]"));
  const sections = Array.from(document.querySelectorAll("[data-section]"));

  if (!navigation || !toggleButton || !navPanel) {
    return;
  }

  const setOpen = (isOpen) => {
    navigation.classList.toggle("-open", isOpen);
    toggleButton.classList.toggle("-open", isOpen);
    toggleButton.setAttribute("aria-expanded", String(isOpen));
    navPanel.setAttribute("aria-hidden", String(!isOpen));
    document.body.classList.toggle("has-open-navigation", isOpen);
  };

  toggleButton.addEventListener("click", () => {
    setOpen(!navigation.classList.contains("-open"));
  });

  navLinks.forEach((link) => {
    link.addEventListener("click", () => setOpen(false));
  });

  window.addEventListener("resize", () => setOpen(false));

  if (sections.length === 0) {
    return;
  }

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      const currentSection = slugify(entry.target.dataset.section || "");

      navLinks.forEach((link) => {
        const target = link.getAttribute("href")?.replace("#", "") || "";
        link.classList.toggle("-active", target === currentSection);
      });
    });
  }, {
    root: null,
    threshold: 0.1,
  });

  sections.forEach((section) => sectionObserver.observe(section));
};
